export default __webpack_public_path__ + "static/media/advantages__item-icon-6.aad7863f.svg";